export default __webpack_public_path__ + "static/media/f15.c69068f5.jpg";